import { Component, EventEmitter, Input, Output } from "@angular/core";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
	selector: "fly-toggle-switch",
	template: `
		<label
			[for]="id"
			class="fly-toggle-switch">
			<input
				(change)="onToggle()"
				[checked]="currentValue"
				[disabled]="disabled"
				[id]="id"
				type="checkbox">
			<span [ngClass]="{'fly-toggle-switch-slider round': true, 'disabled': disabled}"></span>
		</label>
	`,
	styles: [`
		.fly-toggle-switch {
			position: relative;
			display: inline-block;
			width: 54px;
			height: 30px;
			margin-bottom: 0;
		}

		/* Hide default HTML checkbox */
		.fly-toggle-switch input {
			width: 0;
			height: 0;
			opacity: 0;
		}

		/* The slider */
		.fly-toggle-switch-slider {
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			cursor: pointer;
			background-color: #ccc;
			-webkit-transition: .4s;
			transition: .4s;
		}

		.fly-toggle-switch-slider.disabled {
			cursor: not-allowed;
			opacity: 0.4;
		}

		.fly-toggle-switch-slider::before {
			position: absolute;
			bottom: 4px;
			left: 4px;
			width: 22px;
			height: 22px;
			content: "";
			background-color: #fff;
			-webkit-transition: .4s;
			transition: .4s;
		}

		input:checked + .fly-toggle-switch-slider {
			background-color: #0071ce;
		}

		input:focus + .fly-toggle-switch-slider {
			box-shadow: 0 0 1px #0071ce;
		}

		input:checked + .fly-toggle-switch-slider::before {
			-webkit-transform: translateX(24px);
			-ms-transform: translateX(24px);
			transform: translateX(24px);
		}

		/* Rounded sliders */
		.fly-toggle-switch-slider.round {
			border-radius: 30px;
		}

		.fly-toggle-switch-slider.round::before {
			border-radius: 50%;
		}
	`],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi:true,
			useExisting: ToggleSwitchComponent
		}
	]
})
export class ToggleSwitchComponent implements ControlValueAccessor {
	@Input() currentValue: boolean;
	@Input() disabled: boolean = false;
	@Output() readonly valueChanged = new EventEmitter<boolean>();
	id: string = `checkbox-${this.generateRandomId()}`;
	onChange = (_: any) => {};
	onTouched = () => {};
	touched = false;

	onToggle() {
		if ( !this.touched ) {
			this.onTouched();
			this.touched = true;
		}
		if (!this.disabled) {
			this.currentValue = !this.currentValue;
			this.valueChanged.emit(this.currentValue);
			this.onChange(this.currentValue);
		}
	}

	private generateRandomId(): string {
		return Math.floor(Math.random() * 100000).toString();
	}

	writeValue(currentValue: boolean): void {
		this.currentValue = currentValue;
	}

	registerOnChange(fn: (value: any) => void): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}

	setDisabledState?(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}
}
